import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-image-gallery]';
export const PLUGIN_NAME = 'imageGallery';


$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
	const element = this;
	System.import(/* webpackChunkName: "components/gallery" */
	'./component').then(() => {
			$(element)[PLUGIN_NAME]();
    });
  });
});

console.log("HELLO!");


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/blocks/gallery/index.js